<template>
    <v-dialog max-width="60%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0">
                <v-text-field v-model="keyName"
                              class="ml-5 mr-5 mb-0"
                              label="Key"
                              outlined></v-text-field>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0">
                <v-textarea v-model="valueName"
                              class="ml-5 mr-5 mt-0"
                              label="Value"
                              outlined></v-textarea>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        :loading="buttonLoading"
                        class="ma-2"
                        color="primary"
                        @click="onPressUse">CREATE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {LocalizationStoreUtils} from "@/modules/mlocalization/database/LocalizationStoreUtils";
import {uuid} from "vue-uuid";

export default {
    name: "l-add-key-popup",
    props: {},
    data: () => ({
        buttonLoading: false,
        dialog: false,
        keyName: "",
        valueName: "",
        group_id: "",
        language: "",
    }),
    computed: {},
    methods: {
        show(group_id, language) {
            this.group_id = group_id
            this.language = language
            this.dialog = true
            this.keyName = ''
            this.valueName = ''
        },
        hide() {
            this.dialog = true
        },
        onClose() {
            this.dialog = false
        },
        onPressUse() {
            if (this.keyName == ''){
                this.$notify({title: 'Key Its Empty!', type: "error"});
                return
            }
            if (this.valueName == ''){
                this.$notify({title: 'Value Its Empty!', type: "error"});
                return
            }

            this.buttonLoading = true

            let data = {
                key_name: this.keyName.replace(/\s/g,''),
                key_id: uuid.v4().replace(/-/g, ""),
                group_id: this.group_id
            }
            data[this.language.name] = this.valueName
            LocalizationStoreUtils.addKey(data)
            .then(() => {
                this.buttonLoading = false
                this.dialog = false
                this.$notify({title: 'Item successfully added!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.buttonLoading = false
                this.$notify({title: 'Item add failed!', text: error, type: "error"});
            })
        }
    }
}
</script>

<style scoped>

</style>